import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { useFieldValue } from "formik";
import { ControlState } from "../models/flexible/control-state";
import { isEmptyValue } from "../utils/is-empty-value";
import { GeneralFieldController } from "./general-field-controller";

export class ProceedWithoutReviewController extends GeneralFieldController {
	override mapInitialValue(value: unknown): unknown {
		return this.getIsNegotiationDecision() ? null : value;
	}

	override useControlState(): ControlState {
		const [fieldValue] = useFieldValue(AttributeIdentifiers.ProceedWithoutReview);
		return isEmptyValue(fieldValue) && this.getIsNegotiationDecision() ? "hidden" : "enabled";
	}

	private getIsNegotiationDecision() {
		return this.parent.context.cases.some((caseInstance) => caseInstance.negotiationRounds.some((round) => round.updatedBy.length));
	}
}
